import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const userAigeneratedStories = async (payload) => {
  // payload should contain: { userId, title }
  const response = await apiService.post(apiRoutes.userAigeneratedStories, payload);
  return response.data;
};

export const aigeneratedStoriesDetail = async (payload) => {
  const response = await apiService.post(apiRoutes.aigeneratedStoriesDetail, payload);
  return response.data;
};

